module.exports = __webpack_public_path__ + "img/cangku.b69efa37.png";